export enum SettingsTabKeys {
  Settings = 'settings',
  Units = 'units',
  Responsiveness = 'responsiveness',
  Favorite = 'favoriteLocations',
  Notifications = 'notifications',
  ApiServices = 'apiServices',
  Mobile = 'mobileApps',
  Notes = 'notes',
}

export enum StoreLinksType {
  Apple = 'apple',
  Google = 'google',
}
